import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import dependencyInjectionInfrastructure from "./infrastructure/dependencyInjectorInfrastructureSearch";
import dependencyInjectionApplication from "./application/dependency_injector_application";
import SearchBar from "./presentation/components/SearchBar";
import { useState, useEffect } from "react";
import { EventBus } from "./infrastructure/commons/eventBus/eventBus";
import "./infrastructure/i18n/i18n";
import { container } from "tsyringe";
import { useLogrocket } from "./infrastructure/utils/logrocket";
const CHECKOUT_BABY_SEAT_SELECTION_KEY = "checkoutBabySeatSelection";
const CHECKOUT_BABY_SEAT_RESTORE_KEY = "checkoutBabySeatRestore";
const CHECKOUT_BABY_SEAT_INFANT_COUNT_KEY = "checkoutBabySeatInfantCount";
const CHECKOUT_BABY_SEAT_CHILD_COUNT_KEY = "checkoutBabySeatChildCount";
const CHECKOUT_BABY_SEAT_BOOSTER_COUNT_KEY = "checkoutBabySeatBoosterCount";
export const AppSearchBar = () => {
    dependencyInjectionInfrastructure();
    dependencyInjectionApplication();
    useLogrocket();
    // Resolver DI
    const dataStore = container.resolve("IUseStoreAplication");
    const { setIpLocation } = dataStore.actions;
    // -- End Resolver DI
    const [showSearchBarApp, setShowSearchBarApp] = useState(true);
    useEffect(() => {
        let modalRootLoading = document.getElementsByTagName("sticky-header");
        if (modalRootLoading === undefined || modalRootLoading.length === 0) {
            modalRootLoading = document.getElementsByTagName("header");
        }
        setIpLoaction();
        EventBus.getInstance().on("ShowSearchBarApp", (data) => {
            //if searchBar contains the class show, then execute an if
            setShowSearchBarApp(data.value);
        });
    }, []);
    useEffect(() => {
        if (!showSearchBarApp)
            return;
        const pathname = window.location.pathname.toLowerCase();
        const isProductDetailsPage = pathname.includes("/products/vehicle");
        if (isProductDetailsPage)
            return;
        sessionStorage.removeItem(CHECKOUT_BABY_SEAT_RESTORE_KEY);
        sessionStorage.removeItem(CHECKOUT_BABY_SEAT_SELECTION_KEY);
        sessionStorage.removeItem(CHECKOUT_BABY_SEAT_INFANT_COUNT_KEY);
        sessionStorage.removeItem(CHECKOUT_BABY_SEAT_CHILD_COUNT_KEY);
        sessionStorage.removeItem(CHECKOUT_BABY_SEAT_BOOSTER_COUNT_KEY);
    }, [showSearchBarApp]);
    const setIpLoaction = () => {
        const countryData = sessionStorage.getItem("geo_ip_location") ? JSON.parse(sessionStorage.getItem("geo_ip_location") || "{}") : {};
        document.body.addEventListener("theme::current::ip", (event) => {
            const customEvent = event;
            setIpLocation(customEvent.detail.country);
        });
        setIpLocation(countryData);
    };
    return (_jsx(_Fragment, { children: showSearchBarApp && (_jsx("div", { className: "App", children: _jsx(SearchBar, {}) })) }));
};
export default AppSearchBar;
